import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash';

import { Checkmark } from 'components/svg';
import { Text } from 'components/core/Text';

function enhance(WrappedComponent) {
	function WithSearchOnMoveLogic({ onToggleSearchOnMove = noop, ...rest }) {
		const handleToggleSearchOnMove = () => {
			onToggleSearchOnMove();
		};

		return (
			<WrappedComponent
				{...rest}
				onToggleSearchOnMove={onToggleSearchOnMove}
				handleToggleSearchOnMove={handleToggleSearchOnMove}
			/>
		);
	}
	return WithSearchOnMoveLogic;
}

export function SearchOnMove({ searchOnMove, handleToggleSearchOnMove }) {
	return (
		<button
			type="button"
			className="search-on-move-container"
			onClick={handleToggleSearchOnMove}
		>
			<span className={classnames('checkbox', { checked: searchOnMove })}>
				<Checkmark />
			</span>
			<Text>Search when I move the map</Text>
		</button>
	);
}

SearchOnMove.propTypes = {
	handleToggleSearchOnMove: PropTypes.func,
	searchOnMove: PropTypes.bool
};

export default enhance(SearchOnMove);
